import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {GetLeadConfigurationRequest} from '../Requests/GetLeadConfigurationRequest.js'

class GetLeadConfigurationSellerUseCase extends UseCase {
  #repository
  #isFeatureEnabled

  constructor({repository, isFeatureEnabled}) {
    super()
    this.#repository = repository
    this.#isFeatureEnabled = isFeatureEnabled
  }

  static create({config, repository}) {
    const isMotos = config.get('APP_NAME') === config.get('APP_NAME_MOTOS')
    return new GetLeadConfigurationSellerUseCase({
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      isFeatureEnabled: !isMotos
    })
  }

  @tracer({metric: 'GetLeadConfigurationSellerUseCase#execute'})
  @AsyncInlineError()
  async execute(params) {
    if (!this.#isFeatureEnabled) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }
    const {makeId, variationKey} = params
    const getLeadConfigurationRequest = GetLeadConfigurationRequest.create({makeId, variationKey})
    const [error, response] = await this.#repository.getLeadConfiguration({getLeadConfigurationRequest})

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = GetLeadConfigurationSellerUseCase.create
